export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      files: [
        {
          fileId: 13,
          fileUuid: "files013",
          fileName: "video01.mp3",
          fileUri: "/mp4/video01.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 12,
          fileUuid: "files012",
          fileName: "video02.mp3",
          fileUri: "/mp4/video02.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services002",
              serviceName: "〇〇地域サポート"
            },
            {
              serviceUuid: "services004",
              serviceName: "△△地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        },
        {
          fileId: 11,
          fileUuid: "files011",
          fileName: "video03.mp3",
          fileUri: "/mp4/video03.mp3",
          thumbnailUri: "/images/img01.png",
          fileContentsType: "image/png",
          fileSize: 1234,
          serviceKbn: 1,
          services: [
            {
              serviceUuid: "services001",
              serviceName: "アイラ地域サポート"
            }
          ],
          createdAt: 1234567890123,
          updatedAt: 1234567890123
        }
      ]
    }
  }
}